const API_URL = process.env.REACT_APP_API_URL;

let apiUrls =  {
    elements: `${API_URL}/shrink-wrapping-types`,
    information: `${API_URL}/shrink-wrapping-type/information`
};

export default apiUrls;
